import get from 'lodash/get';

export default function isCheckingFormModified(formData, defaultState) {
  const details = get(formData, 'paymentOption.details');

  if (details) {
    return formData.firstName !== defaultState.firstName
      || formData.lastName !== defaultState.lastName;
  }

  return formData.accountNumber !== defaultState.accountNumber
    || formData.routingNumber !== defaultState.routingNumber
    || formData.firstName !== defaultState.firstName
    || formData.lastName !== defaultState.lastName;
}
